import { EntityTask } from "types/Models/bookkeepingTracker";

export const taskDummyData: (EntityTask & { subRows?: EntityTask[] })[] = [
  {
    name: "",
    uuid: "",
    created_at: "",
    completed_on: "",
    deadline: "",
    from_date: "",
    to_date: "",
    accounting_method: "",
    assigned_to: {
      uuid: "",
      name: "",
    },
    assigned_at: "",
    template: {
      uuid: "",
    },
    parent_task_template_id: "",
    assigned_team: {
      name: "",
      uuid: "",
      category: "",
    },
    estimated_time_of_delivery: {
      date: "",
      color: "",
    },
    channel: "",
    cpa_private_channel: "",
    tags: [],
    notes_count: 0,
    status: "",
    bookkeeping_task_start_date: "",
    books_global_status: null,
    is_archived: false,
    state: {
      uuid: "",
      type: "",
      name: "",
    },
    state_details: {
      type: "",
    },
  },
  {
    name: "",
    uuid: "",
    created_at: "",
    completed_on: "",
    deadline: "",
    from_date: "",
    to_date: "",
    accounting_method: "",
    assigned_to: {
      uuid: "",
      name: "",
    },
    assigned_at: "",
    template: {
      uuid: "",
    },
    parent_task_template_id: "",
    assigned_team: {
      name: "",
      uuid: "",
      category: "",
    },
    estimated_time_of_delivery: {
      date: "",
      color: "",
    },
    channel: "",
    cpa_private_channel: "",
    tags: [],
    notes_count: 0,
    status: "",
    bookkeeping_task_start_date: "",
    books_global_status: null,
    state: {
      uuid: "",
      type: "",
      name: "",
    },
    is_archived: false,
    state_details: {
      type: "",
    },
  },
  {
    name: "",
    uuid: "",
    created_at: "",
    completed_on: "",
    deadline: "",
    from_date: "",
    to_date: "",
    accounting_method: "",
    assigned_to: {
      uuid: "",
      name: "",
    },
    assigned_at: "",
    template: {
      uuid: "",
    },
    parent_task_template_id: "",
    assigned_team: {
      name: "",
      uuid: "",
      category: "",
    },
    estimated_time_of_delivery: {
      date: "",
      color: "",
    },
    channel: "",
    cpa_private_channel: "",
    tags: [],
    notes_count: 0,
    status: "",
    bookkeeping_task_start_date: "",
    books_global_status: null,
    state: {
      uuid: "",
      type: "",
      name: "",
    },
    is_archived: false,
    state_details: {
      type: "",
    },
  },
];
